import type { Contract } from '../types';

/** UI entry only: review and the API's signing checks still run before signing. */
export function canSignContract(
  contract: Contract,
  role?: 'company' | 'person'
): boolean {
  if (
    !role ||
    !['current', 'proposed'].includes(contract.versionStatus ?? 'current') ||
    contract.supersededByContractId ||
    contract.draftStatus === 'draft_rejected' ||
    contract.draftStatus === 'signed_by_both' ||
    contract.signingStatus === 'signed' ||
    contract.signingStatus === 'declined' ||
    (contract.companySigned && contract.personSigned)
  )
    return false;

  if (role === 'company') {
    return (
      !contract.companySigned && contract.draftStatus !== 'signed_by_company'
    );
  }
  return (
    !contract.personSigned &&
    contract.draftStatus !== 'signed_by_person' &&
    Boolean(contract.externalSigningProcessId) &&
    ['sent', 'pending_signature'].includes(contract.signingStatus ?? '')
  );
}
